/* global axios */
import ApiClient from './ApiClient';

// Lia Vigia: /api/v1/accounts/:account_id/vigia/{summary,findings,config}
class VigiaAPI extends ApiClient {
  constructor() {
    super('vigia', { accountScoped: true });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  findings(params = {}) {
    return axios.get(`${this.url}/findings`, { params });
  }

  act(id, payload) {
    return axios.patch(`${this.url}/findings/${id}`, payload);
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  saveConfig(settings) {
    return axios.put(`${this.url}/config`, { settings });
  }
}

export default new VigiaAPI();
